export const CREATE_SERVICE_FEE_WIDGET_NAME = 'CREATE_SERVICE_FEE';
export const ASSISTANT_APP_DEF_ID = '9b806498-035e-44e1-8b82-cbc23d92089a';
export const OLO_APP_DEF_ID = '9a5d83fd-8570-482e-81ab-cfa88942ee60';
export const SERVICE_FEE_CREATED_SIDE_EFFECT = 'service-fee-created';
//# sourceMappingURL=consts.js.map